
import React from "react";

import { Button } from "@heroui/react";
import LogoutIcon from '@mui/icons-material/Logout';

import { useNavigate } from "react-router";
import { useAuth } from "../hooks/useAuth";
import { IconButton } from "@mui/material";
import TextLabel from "./typography/TextLabel";


export default function SignOutButton({ variant: buttonVariant }: { variant?: "icon" | "button" }) {

    const { logout } = useAuth();
    const navigate = useNavigate();

    const signOut = React.useCallback(async () => {
        await logout();
        navigate('/sign-in');
    }, [logout, navigate]);
    return (
        <>
            {/* {(buttonVariant == "button") ? <Button
                variant="flat"
                size="lg"
                fullWidth onPress={signOut}
                style={{ marginTop: 'auto' }}
                endContent={<LogoutIcon />}
            >
                Logout
            </Button> : <IconButton onClick={signOut}><LogoutIcon /></IconButton>} */}

            <Button
                variant="flat"
                size="sm"
                fullWidth onPress={signOut}
                endContent={<LogoutIcon fontSize="small" />}
            ><TextLabel>Logout</TextLabel></Button>
        </>
    )
}